import React, { useState, useContext } from "react";
import { UserContext } from "../UserContext";
import { Box, Typography } from "@mui/material";
import Button from "./elements/Button";
import { Link } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


export const LoginForm = () => {
   const { handleLogin, flashMessage } = useContext(UserContext);
   const [formSubmitted, setFormSubmitted] = useState(false);
   const [showPassword, setShowPassword] = useState(false);
   const [formData, setFormData] = useState({
       username: "",
       password: "",
   });

   const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value }); // Ensure that the keys are 'username' and 'password'
  };
  

   const handleSubmit = async (e) => {
      e.preventDefault();
      setFormSubmitted(true); 
      handleLogin(formData.username, formData.password);
  }

   const toggleShowPassword = () => {
      setShowPassword(!showPassword)
   }

   return(
      <Box margin="10px">
         <section className="mt-8">
            <Box className="container mt-10">
               <Box className="flex flex-wrap -mx-4">
                  <Box className="w-full px-4">
                     <Box className="max-w-[525px] bg-transparent mx-auto rounded-lg relative overflow-hidden
                        py-8
                        px-10
                        sm:px-12
                        md:px-[60px]
                        "
                        >
                        <Box className="mb-5 md:mb-8 text-center">
                           <img 
                              src={require("../assets/images/logo.png")} 
                              alt="TripHub Logo"
                              className="w-55 h-20 mx-auto"
                           />
                        </Box>
                        <form onSubmit={handleSubmit}>
                           <Typography 
                              variant="h5"
                              sx={{ 
                                 fontWeight:"500", 
                                 fontSize:"16px", 
                                 marginTop: "-5%",
                                 textAlign: "center"
                              }}
                              gutterBottom
                           >
                              Welcome back!
                           </Typography>
                           <Box className="mt-4 mb-4">
                           {flashMessage && (
                              <div className={`text-center my-3 ${flashMessage.type === 'success' ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>
                                 {flashMessage.message}
                              </div>
                           )}
                              <label htmlFor="username">
                                 Username <br />
                                 <input
                                    name="username"
                                    type="text"
                                    placeholder="Username"
                                    className="
                                    w-full
                                    rounded-md
                                    border
                                    border-[#E9EDF4]
                                    py-3
                                    px-5
                                    bg-[#FCFDFE]
                                    text-black
                                    placeholder-[#ACB6BE]
                                    outline-none
                                    focus-visible:shadow-none
                                    focus:border-pry
                                    "
                                    value={formData.username}
                                    onChange={handleChange}
                                 />
                              </label>
                           </Box>
                           <Box className="mb-3 relative">
                              <label htmlFor="password">
                                 Password <br />
                                 <input
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    className="
                                    w-full
                                    rounded-md
                                    border
                                    border-[#E9EDF4]
                                    py-3
                                    px-5
                                    bg-[#FCFDFE]
                                    text-black
                                    placeholder-[#ACB6BE]
                                    outline-none
                                    focus-visible:shadow-none
                                    focus:border-pry"
                                    value={formData.password}
                                    onChange={handleChange}
                                 />
                              </label>
                              <button
                                 type="button"
                                 className="absolute inset-y-0 right-0 pr-3 pt-5 flex items-center"
                                 onClick={toggleShowPassword}
                              >
                                 {showPassword ? 
                                    <VisibilityOffIcon /> : <VisibilityIcon />}
                              </button>
                              </Box>
                           <Box>
                              <Link to="/forget-password">
                                 <Typography 
                                    variant="h6" 
                                    paragraph 
                                    className=""
                                    sx={{ 
                                       fontWeight:"300", 
                                       textAlign: "right",
                                       fontSize: "16px" 
                                    }}
                                 >
                                    Forget password?
                                 </Typography>
                              </Link>
                           </Box>
                           <Box className="mt-[-6%] mb-5">
                              <Button 
                                 size="large" 
                                 className="px-12"
                                 type="submit" 
                              >
                                 Login
                              </Button>
                                 <Typography 
                                    variant="h6" 
                                    paragraph
                                    sx={{
                                       fontWeight: "400",
                                       textAlign: "center",
                                       marginTop: "10px",
                                       marginBottom: "50px",
                                       fontSize: "14px"
                                    }}
                                    className="text-gray-500"
                                 >
                                    Cancel
                              </Typography>
                           </Box>
                        </form>
                        <Box
                           sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center"
                           }}
                           >
                           <Typography
                              variant="h6"
                              paragraph
                              sx={{
                                 fontSize: "14px",
                                 fontWeight: "300"
                              }}
                              className="text-fadd"
                           >
                              New to TripHub?
                           </Typography>

                           <Link to="/register" sx={{ display: 'flex', alignItems: 'center' }}>
                              <Typography
                                 variant="h6"
                                 sx={{
                                 fontSize: "14px",
                                 textAlign: "right"
                                 }}
                                 className="text-pry inline"
                              >
                                 Get Started
                              </Typography>
                              <span className="inline text-pry">
                                 <ArrowForwardIcon sx={{ color: "#7159EA", ml: 1 }} />
                              </span>
                           </Link>
                           </Box>

                        </Box>
                     </Box>
                  </Box>
               </Box>
            </section>
      </Box>
   )
}
